import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { ReactNode, useRef, useState } from "react";
import { Button, ButtonGroup, Menu } from "..";
import { ButtonGroupProps } from "@mui/material";

//const options = ["Create a merge commit", "Squash and merge", "Rebase and merge"];

export type MenuButtonOption = {
  label: string;
  action: () => void;
};

export const MenuButton = (
  props: ButtonGroupProps & {
    label: ReactNode;
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
    options: MenuButtonOption[];
  }
) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <ButtonGroup variant={props.variant || "outlined"} size={props.size}>
      <Button onClick={props.onClick}>{props.label}</Button>

      <Button onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ width: "15px" }} size="small">
        <ArrowDropDownIcon />
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {props.options.map((option, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              option.action();
              setAnchorEl(null);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </ButtonGroup>
  );
};
